/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import {
  getTheme,
  FontSizes,
  IButtonStyles,
  IStackItemStyles,
  IStackStyles,
  IStackTokens,
  ITextStyles,
} from "@fluentui/react";

const theme = getTheme();

export const headerStackStyles = (): IStackStyles => {
  return {
    root: {
      padding: "1.5rem",
      backgroundColor: theme.palette.white,
      borderRadius: "0.5rem",
    },
  };
};

export const bolderTextStyles = (): ITextStyles => {
  return { root: { fontSize: FontSizes.size20, fontWeight: 600 } };
};

export const normalTextStyles = (): ITextStyles => {
  return { root: { fontSize: FontSizes.size16, fontWeight: 400 } };
};

export const isCompetitorTextStyles = (): ITextStyles => {
  return { root: { fontSize: FontSizes.size20, fontWeight: 600, color: "red" } };
};

export const bolderTextStylesSmall = (): ITextStyles => {
  return { root: { fontSize: FontSizes.size16, fontWeight: 600 } };
};

export const isCompetitorTextStylesSmall = (): ITextStyles => {
  return { root: { fontSize: FontSizes.size16, fontWeight: 600, color: "red" } };
};

export const privateProfileTextStyles = (): ITextStyles => {
  return {
    root: {
      fontSize: FontSizes.size16,
      lineHeight: "1.375 rem",
      fontWeight: 600,
      color: "#FF0000",
    },
  };
};

export const contentStackTokens = (): IStackTokens => {
  return { childrenGap: 24, padding: "0.5rem 0 0 0" };
};

export const headerStackTokens = (): IStackTokens => {
  return { childrenGap: 15 };
};

export const contentStackStyles = (): IStackItemStyles => {
  return {
    root: {
      minWidth: "30%",
    },
  };
};

export const applicationContentStackStyles = (): IStackItemStyles => {
  return {
    root: {
      minWidth: "20%",
    },
  };
};

export const updateButtonStyles: IButtonStyles = {
  root: {
    padding: "4px 2px",
    margin: "0 10px",
    minWidth: "90px",
  },
  label: {
    fontSize: FontSizes.size16,
    color: theme.palette.blue,
  },
};
